import { Button, Stack, Text, tokens } from '@hotjar/hotsauce';
import styled from '@emotion/styled';
import { Trans, useTranslationWithPrefix, useHelpHotjarUrl } from '@hotjar/translations';
import downgradedToBasic from '../../resources/images/downgraded-to-basic.svg';
import { prettifyDate } from '~/subscription-management/utils/date.utils';
import { CONTACT_SUPPORT_LINK, CUSTOM_PRICING } from '~/subscription-management/constants/links';
import { CHECKOUT } from '~/subscription-management/constants/routes';

const S = {
  Stack: styled(Stack)`
    border: 1px solid ${tokens.color.ui_border};
    border-radius: ${tokens.spacer.x0pt5};
    padding: ${tokens.spacer.x2};
    background-color: white;
    background-image: radial-gradient(
      105% 167.79% at 100% 80.34%,
      rgba(161, 143, 214, 0.5) -9.57%,
      rgba(195, 240, 247, 0.5) 26.85%,
      rgba(195, 240, 247, 0) 108%
    );
  `,
  DescriptionContainer: styled.div`
    padding-top: ${tokens.spacer.x1};
  `,
  Text: styled(Text)`
    margin-bottom: ${tokens.spacer.x2};
  `,
};

interface Props {
  nextBillingDate: string;
  disableManageSubscription: boolean;
}

export function ChurnBanner({ nextBillingDate, disableManageSubscription }: Props): JSX.Element {
  const { t } = useTranslationWithPrefix('checkout:churn.banner');
  const helpHotjarUrl = useHelpHotjarUrl();

  return (
    <S.Stack direction="row" spacing="x3">
      <img src={downgradedToBasic} alt="" />
      <S.DescriptionContainer>
        <S.Text as="h5" textType="header5">
          {t('title')}
        </S.Text>
        <S.Text as="p" textType="body2" textColor="text_light">
          <Trans
            i18nKey="checkout:churn.banner.description"
            components={[<span>{prettifyDate(nextBillingDate)}</span>, <br />]}
          />
        </S.Text>

        {disableManageSubscription && (
          <Button
            as="a"
            kind="secondary"
            isExternal
            href={`${helpHotjarUrl}${CONTACT_SUPPORT_LINK}`}
          >
            {t('buttons.contact-support')}
          </Button>
        )}

        {!disableManageSubscription && (
          <Stack spacing="x2">
            <Button as="a" href={CHECKOUT}>
              {t('buttons.manage-subscriptions')}
            </Button>
            <Button as="a" kind="secondary" isExternal href={CUSTOM_PRICING}>
              {t('buttons.explore-lower-plans')}
            </Button>
          </Stack>
        )}
      </S.DescriptionContainer>
    </S.Stack>
  );
}
